<template lang="pug">
div
	.md-layout.md-gutter.md-alignment-center-top.center
		.md-layout-item.md-alignment-center-center.md-medium-size-33.md-small-size-100
			.card-expansion
				md-card(style="width: 100%; height: 100%")
					md-card-media
						img(src='../assets/images/nyc-el.jpg' alt='People')
					md-card-header
						.md-title.black Massive Delays
						.md-subhead Vue Material Cereal
					md-card-expand
						md-card-actions(md-alignment='space-between')
							div
								md-button.md-primary.md-raised Fraction
								md-button.md-accent.md-raised Friction
							md-card-expand-trigger
								md-button.md-icon-button
									md-icon keyboard_arrow_down
						md-card-expand-content
							md-card-content.
								
								Λορεμ ιπσθμ δολορ σιτ αμετ, qθι ει ερρορ επιcθρει σιγνιφερθμqθε. Ναμ τε γραεcο προπριαε, αδ ταcιματεσ μοδερατιθσ δισσεντιθντ πρι. Λεγερε ιισqθε ελοqθεντιαμ vελ θτ. Εστ νιηιλ ελαβοραρετ ιν. Ιδ vελ φαλλι τραcτατοσ σcριπσεριτ, ει ιθσ ζριλ φαcιλισι ηονεστατισ.

		.md-layout-item.md-alignment-top-center.md-medium-size-33.md-small-size-100

			.card-expansion.md-alignment-top-center
				md-card(style="width: 100%; height: 100%;")
					md-card-media
						img(src='../assets/images/nyc-el.jpg' alt='People')
					md-card-header
						.md-title.black Testing Testing
						.md-subhead Beaming Signals To UFOs	
					md-card-expand
						md-card-actions(md-alignment='space-between')
							div
								md-button.md-accent.md-raised Fruition
								md-button.md-primary.md-raised Fiction
							md-card-expand-trigger
								md-button.md-icon-button
									md-icon keyboard_arrow_down
						md-card-expand-content
							md-card-content.
								
								Lorem ipsum dolor sit amet, consectetur adipisicing elit. Optio itaque ea, nostrum odio. Dolores, sed accusantium quasi non, voluptas eius illo quas, saepe voluptate pariatur in deleniti minus sint. Excepturi.
								


		.md-layout-item.md-alignment-center-center.md-medium-size-33.md-small-size-100

			.card-expansion
				md-card(style="width: 100%; height: 100%;")
					md-card-media
						img(src='../assets/images/nyc-el.jpg' alt='People')
					md-card-header
						.md-title.black Three Card Montezuma 
						.md-subhead An Eye on the Suicide King
					md-card-expand
						md-card-actions(md-alignment='space-between')
							div
								md-button.md-accent.md-raised Infraction
								md-button.md-primary.md-raised Traction
							md-card-expand-trigger
								md-button.md-icon-button
									md-icon keyboard_arrow_down
						md-card-expand-content
							md-card-content.
								
								Lorem ipsum dolor sit amet, consectetur adipisicing elit. Optio itaque ea, nostrum odio. Dolores, sed accusantium quasi non, voluptas eius illo quas, saepe voluptate pariatur in deleniti minus sint. Excepturi.




</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'

export default {
	name: 'Home',
	components: {
		HelloWorld
	}
}
</script>

<style lang="scss" scoped>
  .md-card {
    width: 320px;
    margin: 4px;
    display: inline-block;
	vertical-align: top;
	padding: 25px;
	text-align: left;
  }

.md-subhead {
	font-size: 18px !important;
	margin-top: 7px !important;
}

</style>